export default function Header() {
  return (
    <header className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-md z-50 shadow-sm">
      <div className="max-w-6xl mx-auto flex justify-between items-center py-4 px-6">
        {/* Logo Buksy */}
        <div className="flex items-center">
          <img src="/logo.png" alt="Logo" className="h-10 w-25 object-contain" />
        </div>

        {/* Navegación */}
        <nav className="hidden md:flex gap-8 text-gray-600 font-medium">
          <a href="#funciones" className="hover:text-orange-500 transition">Funciones</a>
          <a href="#como-funciona" className="hover:text-orange-500 transition">Cómo funciona</a>
          <a href="#precios" className="hover:text-orange-500 transition">Precios</a>
        </nav>

        {/* Botón principal */}
        <a
          href="https://crm.getbuksy.com/"
          className="relative inline-block rounded-full px-5 py-2.5 text-sm font-semibold text-white overflow-hidden shadow-md transition-all duration-500"
        >
          <span className="absolute inset-0 bg-gradient-to-r from-orange-500 via-yellow-400 to-orange-500 animate-gradientMove rounded-full"></span>
          <span className="relative z-10">Inicio Sesión</span>
        </a>
      </div>
    </header>
  );
}
